
export function checkRole (user, role) {
	user = user.user || user;
	return user.Roles.map(role => role.Role).indexOf(role) !== -1;
}

export default {checkRole}